import React from "react";
import "./RightElements.css";

const MotivationalMission = () => (
  <div className="rightmenu-card motivational-mission-card">
    <div className="section">
      <span className="get-pro-title">Progresează în fiecare zi</span>
      <div className="section-desc" style={{ marginTop: 12 }}>
        Completează obiectivele zilnice și apropie-te de următorul nivel profesional.
      </div>
    </div>
  </div>
);

export default MotivationalMission;
